module.exports = __webpack_public_path__ + "static/media/ResumeFSWD.d8dfa4d8.pdf";